//Panel
import CompanyUserList from "./containers/panel/user/CompanyUserList";
import CompanyUserForm from "./containers/panel/user/CompanyUserForm";
import ConfigurationsForm from "./containers/panel/configurations/ConfigurationsForm";
import ConfigurationsView from "./containers/panel/configurations/ConfigurationsView";
import LevelForm from "./containers/panel/levels/LevelForm";
import LevelList from "./containers/panel/levels/LevelList";
import StudentForm from "./containers/panel/students/StudentForm";
import StudentList from "./containers/panel/students/StudentList";
import CoursesList from "./containers/panel/courses/CoursesList";
import CoursesForm from "./containers/panel/courses/CoursesForm";
import ParallelsList from "./containers/panel/parallels/ParallelsList";
import ParallelsForm from "./containers/panel/parallels/ParallelsForm";
import PolicyList from "./containers/panel/privacy_policy/PolicyList";
import PolicyForm from "./containers/panel/privacy_policy/PolicyForm";
import ContractList from "./containers/panel/contract/ContractList";
import ContractForm from "./containers/panel/contract/ContractForm";
import DocumentationList from "./containers/panel/documentation/DocumentationList";
import DocumentationForm from "./containers/panel/documentation/DocumentationForm";
import FormsList from "./containers/panel/forms/FormsList";
import FormsForm from "./containers/panel/forms/FormsForm";
import SpacePeriodForm from "./containers/panel/configurations/SpacePeriodForm";
import MatriculationPeriodForm from "./containers/panel/configurations/MatriculationPeriodForm";
import StudentProgress from "./containers/panel/students/StudentProgress";
import StudentWithSpaceList from "./containers/panel/reports/places/StudentWithSpaceList";
import StudentWithoutSpaceList from "./containers/panel/reports/places/StudentWithoutSpaceList";
import EventsList from "./containers/panel/events/EventsList";
import EventsForm from "./containers/panel/events/EventsForm";
import ContractReport from "./containers/panel/reports/process_matriculation/ContractReport";
import DocumentReport from "./containers/panel/reports/process_matriculation/DocumentReport";
import FormReport from "./containers/panel/reports/process_matriculation/FormReport";
import ProcesStatusReport from "./containers/panel/reports/process_matriculation/ProcesStatusReport";
import TransportReport from "./containers/panel/reports/transport/TransportReport";

const routes = [
    //Configurations
    {
        path: "/panel/configurations",
        component: ConfigurationsView,
    },
    {
        path: "/panel/configurations/new_configuration",
        component: ConfigurationsForm,
    },
    {
        path: "/panel/configurations/:configuration_id",
        component: ConfigurationsForm,
    },
    {
        path: "/panel/configurations/matriculation_period/:matriculation_period_id",
        component: MatriculationPeriodForm,
    },
    {
        path: "/panel/configurations/space_period/:space_period_id",
        component: SpacePeriodForm,
    },
    //Users
    {
        path: "/panel/users",
        component: CompanyUserList,
    },
    {
        path: "/panel/users/user_new",
        component: CompanyUserForm,
    },
    {
        path: "/panel/users/:user_id",
        component: CompanyUserForm,
    },
    //sections
    {
        path: "/panel/sections",
        component: LevelList,
    },
    {
        path: "/panel/sections/section_new",
        component: LevelForm,
    },
    {
        path: "/panel/sections/:section_id",
        component: LevelForm,
    },
    //courses
    {
        path: "/panel/courses",
        component: CoursesList,
    },
    {
        path: "/panel/courses/course_new",
        component: CoursesForm,
    },
    {
        path: "/panel/courses/:course_id",
        component: CoursesForm,
    },
    //parallels
    {
        path: "/panel/parallels",
        component: ParallelsList,
    },
    {
        path: "/panel/parallels/parallel_new",
        component: ParallelsForm,
    },
    {
        path: "/panel/parallels/:parallel_id",
        component: ParallelsForm,
    },
    //Students
    {
        path: "/panel/students",
        component: StudentList,
    },
    {
        path: "/panel/students/studet_new",
        component: StudentForm,
    },
    {
        path: "/panel/students/:student_id",
        component: StudentForm,
    },
    {
        path: "/panel/students/:student_id/progress",
        component: StudentProgress,
    },

    // Events
    {
        path: "/panel/events",
        component: EventsList,
    },
    {
        path: "/panel/events/event_new",
        component: EventsForm,
    },
    {
        path: "/panel/events/:event_id",
        component: EventsForm,
    },

    //PRIVACY POLICY
    {
        path: "/panel/privacy_policy",
        component: PolicyList,
    },
    {
        path: "/panel/privacy_policy/policy_new",
        component: PolicyForm,
    },
    {
        path: "/panel/privacy_policy/:policy_id",
        component: PolicyForm,
    },
    //CONTRACT
    {
        path: "/panel/contracts",
        component: ContractList,
    },
    {
        path: "/panel/contracts/contract_new",
        component: ContractForm,
    },
    {
        path: "/panel/contracts/:contract_id",
        component: ContractForm,
    },
    //DOCUMENTS
    {
        path: "/panel/documentations",
        component: DocumentationList,
    },
    {
        path: "/panel/documentations/document_new",
        component: DocumentationForm,
    },
    {
        path: "/panel/documentations/:document_id",
        component: DocumentationForm,
    },
    //FORMS
    {
        path: "/panel/forms",
        component: FormsList,
    },
    {
        path: "/panel/forms/form_new",
        component: FormsForm,
    },
    {
        path: "/panel/forms/:form_id",
        component: FormsForm,
    },
    //REPORTS
    {
        path: "/panel/student_with_space",
        component: StudentWithSpaceList,
    },
    {
        path: "/panel/student_without_space",
        component: StudentWithoutSpaceList,
    },
    {
        path: "/panel/reports/contract",
        component: ContractReport,
    },
    {
        path: "/panel/reports/documents",
        component: DocumentReport,
    },
    {
        path: "/panel/reports/forms",
        component: FormReport,
    },
    {
        path: "/panel/reports/proces_status",
        component: ProcesStatusReport,
    },
    {
        path: "/panel/reports/transport",
        component: TransportReport,
    }

];

export default routes;
